import { PASSWORD_RULES } from "@/core/constants";

export const checkPasswordStrength = (password: string) => {
  const safePassword = password || "";

  const controlledRules = PASSWORD_RULES.map((ruleItem) => ({
    ...ruleItem,
    satisfied: ruleItem.rule.test(safePassword),
  }));

  const satisfiedCount = controlledRules.filter((r) => r.satisfied).length;
  const percentage =
    PASSWORD_RULES.length > 0 ? satisfiedCount / PASSWORD_RULES.length : 0;

  const isValid = percentage === 1;

  return { controlledRules, percentage, isValid };
};
